import React, { useState } from "react";
import "./careerform.css";

const CareerForm = () => {

  const [data, setData] = useState({
    name: "",
    phone: "",
    email: "",
    course: "",
    message: ""
  });

  // Handle input change
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const msg =
      `Free Career Help Form:%0A` +
      `Name: ${data.name}%0A` +
      `Phone: ${data.phone}%0A` +
      `Email: ${data.email}%0A` +
      `Course: ${data.course}%0A` +
      `Message: ${data.message}`;

    window.open(`https://wa.me/91 81780 67868?text=${msg}`);
  };

  return (
    <div className="form-div">
      <form className="form-box-div" onSubmit={handleSubmit}>

        <h2>✨ Career Help Form</h2>

        <input
          type="text"
          name="name"
          placeholder="Full Name*"
          value={data.name}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="phone"
          placeholder="10 Digit Phone Number*"
          value={data.phone}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email Address*"
          value={data.email}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="course"
          placeholder="Course Name*"
          value={data.course}
          onChange={handleChange}
          required
        />

        <textarea
          name="message"
          placeholder="How can we help you?"
          value={data.message}
          onChange={handleChange}
        ></textarea>

        <button type="submit">Send Enquiry</button>

      </form>
    </div>
  );
};

export default CareerForm;